<template>
  <w-icon-wrapper icon-name='work-link-icon'>
    <g
      id='_54_Verlinken_Icon'
      data-name='54 Verlinken_Icon'
      transform='translate(29.057 0.131)'
    >
      <path
        id='Pfad_55749'
        d='M-17.886,17.364l-3.467,3.474c-.026.027-.052.053-.079.079a3.313,3.313,0,0,1-4.658-.051,3.242,3.242,0,0,1-.938-2.323,3.246,3.246,0,0,1,.992-2.3l5.123-5.149a3.316,3.316,0,0,1,4.658-.027,1.041,1.041,0,0,0,1.463-.009,1.021,1.021,0,0,0,.3-.728A1.02,1.02,0,0,0-14.8,9.6a5.4,5.4,0,0,0-7.583.044L-27.507,14.8a5.273,5.273,0,0,0-1.55,3.777,5.285,5.285,0,0,0,1.594,3.761,5.37,5.37,0,0,0,3.771,1.536,5.365,5.365,0,0,0,3.816-1.581l3.462-3.479a1.019,1.019,0,0,0,.3-.728,1.02,1.02,0,0,0-.308-.727A1.042,1.042,0,0,0-17.886,17.364Z'
        data-name='Pfad 55749'
        fill='currentColor'
      />
      <path
        id='Pfad_55750'
        d='M-6.651,1.406a5.393,5.393,0,0,0-7.587.045L-17.7,4.929a1.016,1.016,0,0,0-.3.729,1.021,1.021,0,0,0,.307.725,1.04,1.04,0,0,0,1.463-.008L-12.763,2.9a3.3,3.3,0,0,1,4.577-.026A3.239,3.239,0,0,1-7.169,5.165,3.235,3.235,0,0,1-8.077,7.5L-13.2,12.646a3.317,3.317,0,0,1-4.658.028,1.036,1.036,0,0,0-1.462.007,1.019,1.019,0,0,0-.3.731,1.013,1.013,0,0,0,.308.724,5.359,5.359,0,0,0,3.768,1.536,5.366,5.366,0,0,0,3.814-1.58l5.123-5.149a5.279,5.279,0,0,0,1.55-3.778A5.278,5.278,0,0,0-6.651,1.406Z'
        data-name='Pfad 55750'
        fill='currentColor'
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconLink' };
</script>
